import React from "react";
import {
  FooterContainer,
  NavLink,
  Content,
  AccordionStyled,
  AccordionSummaryStyled,
  AccordionDetailsStyled,
} from "./styles";
import Typography from "@mui/material/Typography";
import { Grid, useMediaQuery, useTheme, Button } from "@mui/material";
import { RiArrowDownSLine } from "react-icons/ri";

interface Link {
  text: string;
  url: string;
}

interface FooterSection {
  title: string;
  links: Link[];
}

interface SocialLink {
  src: string;
  url: string;
}

const footerData: FooterSection[] = [
  {
    title: "Sobre o Sebrae",
    links: [
      {
        text: "Conheça o Sebrae",
        url: "https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos",
      },
      {
        text: "O que fazemos",
        url: "https://oqueosebraefaz.com.br/",
      },
      {
        text: "Agência Sebrae de Notícias",
        url: "https://agenciasebrae.com.br/",
      },
      {
        text: "Transparência e Prestação de Contas",
        url: "https://transparencia.sebrae.com.br/mapa",
      },
    ],
  },
  {
    title: "Institucional",
    links: [
      {
        text: "LGPD",
        url: "https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_lgpd",
      },
      {
        text: "Licitações",
        url: "https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_licitacoes",
      },
      {
        text: "Sistemas de Gestão de Fornecedores",
        url: "https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/sistemagestaofornecedores",
      },
      {
        text: "Trabalhe no Sebrae",
        url: "https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/trabalhe_sebrae",
      },
    ],
  },
  {
    title: "Cursos, Eventos e Serviços Sebrae",
    links: [
      {
        text: "Cursos Online gratuitos",
        url: "https://sebrae.com.br/sites/PortalSebrae/cursosonline",
      },
      {
        text: "Serviços digitais",
        url: "https://sebrae.com.br/sites/PortalSebrae/produtoseservicos",
      },
      {
        text: "Conteúdos",
        url: "https://sebrae.com.br/sites/PortalSebrae/conteudos",
      },
      {
        text: "Consultorias",
        url: "https://sebrae.com.br/sites/PortalSebrae/sebraetec",
      },
      {
        text: "Aplicativo Sebrae",
        url: "https://sebrae.com.br/sites/PortalSebrae/aplicativosebrae",
      },
    ],
  },
  {
    title: "Fale Conosco",
    links: [
      {
        text: "Atendimento virtual",
        url: "https://sebrae.com.br/sites/PortalSebrae/faleconosco",
      },
      {
        text: "Encontre o Sebrae no seu Estado",
        url: "https://sebrae.com.br/sites/PortalSebrae/faleconosco",
      },
      {
        text: "Suporte ao Usuário",
        url: "https://sacnacional.sebrae.com.br/",
      },
      {
        text: "Ouvidoria",
        url: "https://sebrae.com.br/sites/PortalSebrae/ouvidoriasebrae",
      },
    ],
  },
];

const social: SocialLink[] = [
  {
    src: require("../../assets/youtube.svg"),
    url: "https://www.youtube.com/user/tvsebrae",
  },
  {
    src: require("../../assets/twitter.svg"),
    url: "https://twitter.com/sebrae",
  },
  {
    src: require("../../assets/linkedin.svg"),
    url: "https://www.linkedin.com/company/sebrae/",
  },
  {
    src: require("../../assets/instagram.svg"),
    url: "https://www.instagram.com/sebrae/",
  },
  {
    src: require("../../assets/facebook.svg"),
    url: "https://www.facebook.com/sebrae",
  },
];

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <FooterContainer>
      <Content>
        {isMobile ? (
          footerData.map((section, index) => (
            <AccordionStyled key={index} style={{ backgroundColor: "#0f438a" }}>
              <AccordionSummaryStyled
                expandIcon={<RiArrowDownSLine style={{ color: "#fff" }} />}
              >
                <Typography fontWeight="bold" color="#fff">
                  {section.title}
                </Typography>
              </AccordionSummaryStyled>
              <AccordionDetailsStyled>
                {section.links.map((link, linkIndex) => (
                  <Typography key={linkIndex} variant="body2">
                    <NavLink href={link.url} target="_blank">
                      {link.text}
                    </NavLink>
                  </Typography>
                ))}
              </AccordionDetailsStyled>
            </AccordionStyled>
          ))
        ) : (
          <Grid container spacing={2}>
            <Grid md={8} item container direction="row">
              <Grid container spacing={2}>
                {footerData.map((section, index) => (
                  <Grid key={index} md={3} item className="footer-column">
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      marginBottom={2}
                      color="#fff"
                    >
                      {section.title}
                    </Typography>
                    {section.links.map((link, linkIndex) => (
                      <Typography key={linkIndex} variant="body2">
                        <NavLink href={link.url} target="_blank">
                          {link.text}
                        </NavLink>
                      </Typography>
                    ))}
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid md={4} item container display="flex" direction="column">
              <Grid container display="flex" justifyContent="flex-end">
                {social.map(({ src, url }, index) => (
                  <Grid
                    key={index}
                    item
                    className="footer-column"
                    textAlign="end"
                    marginLeft={4.5}
                  >
                    <NavLink href={url} target="_blank">
                      <img src={src} alt={""} />
                    </NavLink>
                  </Grid>
                ))}
              </Grid>
              <Grid
                container
                display="flex"
                direction="column"
                justifyContent="flex-end"
                marginBottom={1}
                marginTop={1.625}
              >
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  marginBottom={0.375}
                  color="#fff"
                  display="flex"
                  justifyContent="flex-end"
                >
                  Central de Relacionamento:
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="#fff"
                  display="flex"
                  justifyContent="flex-end"
                >
                  <NavLink href={"tel:+5508005700800"} target="_blank">
                    0800 570 0800
                  </NavLink>
                </Typography>
              </Grid>
              <Grid
                container
                display="flex"
                justifyContent="flex-end"
                gap={0.75}
                marginBottom={1.5}
              >
                <Button
                  variant="outlined"
                  size="small"
                  style={{ color: "#ffffff" }}
                  href="https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/sebrae_english"
                >
                  About Us(English)
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  style={{ color: "#ffffff" }}
                  href="https://sebrae.com.br/sites/PortalSebrae/canais_adicionais/sebrae_espanol"
                >
                  Nosostros (Español)
                </Button>
              </Grid>
              <Grid
                container
                display="flex"
                direction="column"
                justifyContent="flex-end"
              >
                <Typography
                  variant="caption"
                  color="#fff"
                  display="flex"
                  justifyContent="flex-end"
                >
                  &#169; 2021 Sebrae. Todos os direitos reservados.
                </Typography>
                <Typography
                  variant="caption"
                  color="#fff"
                  display="flex"
                  justifyContent="flex-end"
                >
                  &#169; Version Templating | v.1.0.11 - Back | v.3.5.0 - Front
                  | v.3.6.1
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Content>
    </FooterContainer>
  );
};

export default Footer;
